import { Team, User } from '@litlingo/client/dist/types/models';
import { upperFirst } from 'lodash';
import { UserParseError } from './files';

export type TeamKind = 'division' | 'region' | 'management-level';
export type RoleKind = 'roles';

export const unknownFields: { field: TeamKind | RoleKind; label: string }[] = [
  { field: 'division', label: 'Division' },
  { field: 'region', label: 'Region' },
  { field: 'management-level', label: 'Management Level' },
  { field: 'roles', label: 'Roles' },
];

export const TEAM_KIND_CONFIG: Record<
  TeamKind,
  {
    title: string;
    createLabel: string;
    emptyNameError: string;
    successMessage: string;
    emptyTableMessage: string;
  }
> = {
  division: {
    title: 'Divisions',
    createLabel: 'Create New Division',
    emptyNameError: 'Division needs a name',
    successMessage: 'Saved Division',
    emptyTableMessage: 'There are no divisions to display',
  },
  region: {
    title: 'Regions',
    createLabel: 'Create New Region',
    emptyNameError: 'Region needs a name',
    successMessage: 'Saved Region',
    emptyTableMessage: 'There are no regions to display',
  },
  'management-level': {
    title: 'Management Levels',
    createLabel: 'Create New Management Level',
    emptyNameError: 'Management level needs a name',
    successMessage: 'Saved Management Level',
    emptyTableMessage: 'There are no management levels to display',
  },
};

export const teamKindMap: Record<string, TeamKind> = {
  'teams-manager': 'division',
  'regions-manager': 'region',
  'management-level': 'management-level',
};

export const TEAM_FILTER_CONFIG: Record<
  TeamKind,
  {
    placeholder: string;
    emptyLabel: string;
    emptyMessage: string;
  }
> = {
  region: {
    placeholder: 'Region',
    emptyLabel: 'No Region',
    emptyMessage: 'No regions found',
  },
  division: {
    placeholder: 'Division',
    emptyLabel: 'No Team',
    emptyMessage: 'No divisions found',
  },
  'management-level': {
    placeholder: 'Level',
    emptyLabel: 'No Management Level',
    emptyMessage: 'No management levels found',
  },
};

const isSkippedTeamCellValue = (teamName: string): boolean => teamName.toLowerCase() === 'n/a';

export const addTeamsFromCell = (
  user: Partial<User>,
  cellValue: string | undefined,
  field: TeamKind,
  teams: Team[],
  errors: UserParseError[]
): void => {
  if (!cellValue) return;

  cellValue
    .split(',')
    .map((s) => s.trim())
    .forEach((teamName) => {
      if (!teamName || isSkippedTeamCellValue(teamName)) return;

      const team = teams.find(
        // @ts-ignore
        (t) => t.name.toLowerCase().trim() === teamName.toLowerCase().trim() && t.kind === field
      );

      if (team) {
        user.teams?.push(team);
      } else {
        errors.push({
          name: user.email || user.name || '',
          error: {
            type: 'unknown-field',
            field,
            value: upperFirst(teamName),
          },
        });
      }
    });
};
